function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
var _excluded = ['label', 'disabled', 'onClick', 'confirm'];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  );
}
function _nonIterableSpread() {
  throw new TypeError(
    'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _iterableToArray(iter) {
  if (
    (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null) ||
    iter['@@iterator'] != null
  )
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useEffect, useImperativeHandle, useMemo, useState, useRef } from 'react';
import StandardizeTableView from './view';
import { Button, Modal, Space, Switch } from 'udesk-ui';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
import BatchedActions from '../batched-actions';
import { MoreOutlined } from '@udesk/icons';
// import './style/index';
var StandardizeTable = /*#__PURE__*/ React.forwardRef(function (props, ref) {
  var _filter$initialValues, _tableProps$rowSelect, _tableProps$rowSelect2;
  var prefixCls = props.prefixCls,
    className = props.className;
  var table = props.table,
    filter = props.filter,
    classification = props.classification,
    columnsControl = props.columnsControl,
    exportBtn = props.exportBtn,
    batchedActions = props.batchedActions;
  var _useLocaleReceiver = useLocaleReceiver('BatchedActions'),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
    contextLocale = _useLocaleReceiver2[0];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    rowSelectionItems = _useState2[0],
    setRowSelectionItems = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    showColumns = _useState4[0],
    setShowColumns = _useState4[1];
  var _useState5 = useState(
      (_filter$initialValues =
        filter === null || filter === void 0 ? void 0 : filter.initialValues) !== null &&
        _filter$initialValues !== void 0
        ? _filter$initialValues
        : {},
    ),
    _useState6 = _slicedToArray(_useState5, 2),
    filterValues = _useState6[0],
    setFilterValues = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    classificationId = _useState8[0],
    setClassificationId = _useState8[1];
  var _useState9 = useState(
      formatTableProps(table, showColumns, setRowSelectionItems, rowSelectionItems, contextLocale),
    ),
    _useState10 = _slicedToArray(_useState9, 2),
    tableProps = _useState10[0],
    setTableProps = _useState10[1];
  var instance = useRef(null);
  useImperativeHandle(ref, function () {
    return instance.current;
  });
  useEffect(
    function () {
      setTableProps(
        formatTableProps(
          table,
          showColumns,
          setRowSelectionItems,
          rowSelectionItems,
          contextLocale,
        ),
      );
    },
    [table, showColumns, rowSelectionItems],
  );
  useEffect(
    function () {
      if (
        columnsControl === null || columnsControl === void 0
          ? void 0
          : columnsControl.showColumnKeys
      ) {
        setShowColumns(
          columnsControl === null || columnsControl === void 0
            ? void 0
            : columnsControl.showColumnKeys,
        );
      } else {
        var _table$columns$map, _table$columns;
        setShowColumns(
          (_table$columns$map =
            (_table$columns = table.columns) === null || _table$columns === void 0
              ? void 0
              : _table$columns.map(function (c) {
                  return c === null || c === void 0 ? void 0 : c.key;
                })) !== null && _table$columns$map !== void 0
            ? _table$columns$map
            : [],
        );
      }
    },
    [
      columnsControl === null || columnsControl === void 0 ? void 0 : columnsControl.showColumnKeys,
      table.columns,
    ],
  );
  var columnsControlProps = useMemo(
    function () {
      var _table$columns2;
      if (!columnsControl) return undefined;
      return {
        columns:
          (_table$columns2 = table.columns) === null || _table$columns2 === void 0
            ? void 0
            : _table$columns2.filter(Boolean),
        showColumnKeys: showColumns,
        onChange: function onChange(showKeys) {
          var _columnsControl$onCha;
          setShowColumns(showKeys);
          columnsControl === null || columnsControl === void 0
            ? void 0
            : (_columnsControl$onCha = columnsControl.onChange) === null ||
              _columnsControl$onCha === void 0
            ? void 0
            : _columnsControl$onCha.call(columnsControl, showKeys);
        },
      };
    },
    [columnsControl, showColumns, table.columns],
  );
  var filterProps = useMemo(
    function () {
      if (!filter) return undefined;
      return _objectSpread(
        _objectSpread({}, filter),
        {},
        {
          onSearch: function onSearch(v) {
            var _filter$onSearch, _instance$current;
            filter === null || filter === void 0
              ? void 0
              : (_filter$onSearch = filter.onSearch) === null || _filter$onSearch === void 0
              ? void 0
              : _filter$onSearch.call(filter, v, {
                  pagination: Object.assign({}, tableProps.pagination, {
                    current: 1,
                  }),
                  classificationId: classificationId,
                });
            setFilterValues(v);
            (_instance$current = instance.current) === null || _instance$current === void 0
              ? void 0
              : _instance$current.tableInstance.resetToEmpty();
          },
        },
      );
    },
    [filter, tableProps, classification],
  );
  var exportBtnProps = useMemo(
    function () {
      var _table$pagination$tot, _table$pagination;
      if (!exportBtn) return undefined;
      return _objectSpread(
        _objectSpread({}, exportBtn),
        {},
        {
          exportDataCount:
            (_table$pagination$tot =
              table === null || table === void 0
                ? void 0
                : (_table$pagination = table.pagination) === null || _table$pagination === void 0
                ? void 0
                : _table$pagination.total) !== null && _table$pagination$tot !== void 0
              ? _table$pagination$tot
              : 0,
        },
      );
    },
    [exportBtn, table === null || table === void 0 ? void 0 : table.pagination],
  );
  var classificationProps = useMemo(
    function () {
      if (!classification) return undefined;
      var onSelect = function onSelect(selectedKeys) {
        var _classification$onSel, _instance$current2;
        var selectedKeysCopy = _toConsumableArray(selectedKeys);
        var selectedKey = selectedKeysCopy.pop();
        setClassificationId(selectedKey);
        (_classification$onSel = classification.onSelect) === null ||
        _classification$onSel === void 0
          ? void 0
          : _classification$onSel.call(classification, selectedKey, {
              filter: filterValues,
              pagination: Object.assign({}, tableProps.pagination, {
                current: 1,
              }),
            });
        (_instance$current2 = instance.current) === null || _instance$current2 === void 0
          ? void 0
          : _instance$current2.tableInstance.resetToEmpty();
      };
      return _objectSpread(
        _objectSpread(
          {
            indentUnitWidth: 16,
            expandAction: false,
          },
          classification,
        ),
        {},
        {
          onSelect: onSelect,
        },
      );
    },
    [classification, filterValues],
  );
  useEffect(
    function () {
      if (
        Array.isArray(
          classification === null || classification === void 0
            ? void 0
            : classification.selectedKeys,
        ) &&
        (classification === null || classification === void 0
          ? void 0
          : classification.selectedKeys.length)
      ) {
        setClassificationId(classification.selectedKeys[0]);
      }
    },
    [classification],
  );
  var batchedActionsProps = useMemo(
    function () {
      if (!batchedActions) return undefined;
      var items = rowSelectionItems;
      var _ref =
          (tableProps === null || tableProps === void 0
            ? void 0
            : tableProps.rowSelectionEnhance) || {},
        selectedRowKeys = _ref.selectedRowKeys,
        rowKeysFieldName = _ref.rowKeysFieldName,
        onSelectedRowKeysChange = _ref.onSelectedRowKeysChange;
      if (
        (tableProps === null || tableProps === void 0 ? void 0 : tableProps.rowSelectionEnhance) &&
        selectedRowKeys &&
        rowKeysFieldName
      ) {
        items = rowSelectionItems.filter(function (item) {
          return selectedRowKeys.includes(item[rowKeysFieldName]);
        });
      }
      return batchedActions.map(function (i) {
        return _objectSpread(
          _objectSpread({}, i),
          {},
          {
            onClick: function onClick() {
              var _i$onClick, _i$onClick$then;
              return (_i$onClick = i.onClick(items)) === null || _i$onClick === void 0
                ? void 0
                : (_i$onClick$then = _i$onClick.then) === null || _i$onClick$then === void 0
                ? void 0
                : _i$onClick$then.call(_i$onClick, function (res) {
                    onSelectedRowKeysChange === null || onSelectedRowKeysChange === void 0
                      ? void 0
                      : onSelectedRowKeysChange([], []);
                    return res;
                  });
            },
          },
        );
      });
    },
    [batchedActions, rowSelectionItems, tableProps],
  );
  // useEffect(() => {
  //   if (autoTriggerOnSearchOnMount) {
  //     filter?.onSearch?.(filter.initialValues, {
  //       pagination: Object.assign({}, tableProps.pagination, { current: 1 }),
  //       classificationId,
  //     });
  //   }
  // }, []);
  return /*#__PURE__*/ React.createElement(
    StandardizeTableView,
    _objectSpread(
      _objectSpread({}, props),
      {},
      {
        table: tableProps,
        columnsControl: columnsControlProps,
        prefixCls: prefixCls,
        className: className,
        filter: filterProps,
        rowSelectionCount:
          ((_tableProps$rowSelect = tableProps.rowSelectionEnhance) === null ||
          _tableProps$rowSelect === void 0
            ? void 0
            : (_tableProps$rowSelect2 = _tableProps$rowSelect.selectedRowKeys) === null ||
              _tableProps$rowSelect2 === void 0
            ? void 0
            : _tableProps$rowSelect2.length) || 0,
        exportBtn: exportBtnProps,
        classification: classificationProps,
        batchedActions: batchedActionsProps,
        ref: instance,
      },
    ),
  );
});
export default /*#__PURE__*/ React.memo(StandardizeTable);
function formatTableProps(
  table,
  showColumns,
  setRowSelectionItems,
  rowSelectionItems,
  contextLocale,
) {
  var _table$columns$filter, _table$columns3;
  var rowSelectionEnhance = table.rowSelectionEnhance
    ? _objectSpread({}, table.rowSelectionEnhance)
    : undefined;
  if (rowSelectionEnhance) {
    var _rowSelectionEnhance$;
    rowSelectionEnhance.onSelectedRowKeysChange = function (keys, items) {
      var _table$rowSelectionEn, _table$rowSelectionEn2;
      setRowSelectionItems(items);
      (_table$rowSelectionEn = (_table$rowSelectionEn2 = table.rowSelectionEnhance)
        .onSelectedRowKeysChange) === null || _table$rowSelectionEn === void 0
        ? void 0
        : _table$rowSelectionEn.call(_table$rowSelectionEn2, keys, items);
    };
    var key =
      (_rowSelectionEnhance$ = rowSelectionEnhance.rowKeysFieldName) !== null &&
      _rowSelectionEnhance$ !== void 0
        ? _rowSelectionEnhance$
        : 'id';
    if (!rowSelectionEnhance.selectedRowKeys) {
      var _rowSelectionItems$ma;
      rowSelectionEnhance.selectedRowKeys =
        (_rowSelectionItems$ma =
          rowSelectionItems === null || rowSelectionItems === void 0
            ? void 0
            : rowSelectionItems.map(function (i) {
                return i[key];
              })) !== null && _rowSelectionItems$ma !== void 0
          ? _rowSelectionItems$ma
          : [];
    }
  }
  var columns =
    (_table$columns$filter =
      (_table$columns3 = table.columns) === null || _table$columns3 === void 0
        ? void 0
        : _table$columns3
            .filter(function () {
              var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return showColumns.includes(i.key);
            })
            .map(function () {
              var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              if (i.renderType === 'actions') {
                return _objectSpread(
                  {
                    render: function render(text, record, index) {
                      var btnCount = i.buttons.length;
                      var showBtns = _toConsumableArray(i.buttons);
                      var hiddenBtns = [];
                      if (btnCount > 3) {
                        var SHOW_BTNS_COUNT = 2;
                        showBtns.length = SHOW_BTNS_COUNT;
                        hiddenBtns = i.buttons.slice(SHOW_BTNS_COUNT).map(function (i) {
                          var _i$disabled;
                          return _objectSpread(
                            _objectSpread({}, i),
                            {},
                            {
                              onClick: i.onClick.bind(null, record),
                              disabled:
                                typeof i.disabled === 'function'
                                  ? (_i$disabled = i.disabled) === null || _i$disabled === void 0
                                    ? void 0
                                    : _i$disabled.call(i, record)
                                  : i.disabled,
                            },
                          );
                        });
                      }
                      return /*#__PURE__*/ React.createElement(
                        Space,
                        {
                          style: {
                            marginLeft: '-8px',
                          },
                        },
                        showBtns.map(function (b) {
                          var label = b.label,
                            disabled = b.disabled,
                            onClick = b.onClick,
                            confirm = b.confirm,
                            btnProps = _objectWithoutProperties(b, _excluded);
                          return /*#__PURE__*/ React.createElement(
                            Button,
                            _objectSpread(
                              _objectSpread({}, btnProps),
                              {},
                              {
                                onClick:
                                  btnProps.danger || confirm
                                    ? function () {
                                        Modal.confirm(
                                          _objectSpread(
                                            _objectSpread(
                                              _objectSpread({}, contextLocale.lang.confirm),
                                              confirm || {},
                                            ),
                                            {},
                                            {
                                              onOk:
                                                onClick === null || onClick === void 0
                                                  ? void 0
                                                  : onClick.bind(null, record),
                                            },
                                          ),
                                        );
                                      }
                                    : onClick === null || onClick === void 0
                                    ? void 0
                                    : onClick.bind(null, record),
                                disabled:
                                  typeof disabled === 'function'
                                    ? disabled === null || disabled === void 0
                                      ? void 0
                                      : disabled(record)
                                    : disabled,
                                type: 'link',
                                size: 'small',
                              },
                            ),
                            label,
                          );
                        }),
                        hiddenBtns.length > 0 &&
                          /*#__PURE__*/ React.createElement(
                            BatchedActions,
                            {
                              menu: hiddenBtns,
                              trigger: ['click'],
                            },
                            /*#__PURE__*/ React.createElement(Button, {
                              type: 'link',
                              icon: /*#__PURE__*/ React.createElement(MoreOutlined, null),
                            }),
                          ),
                      );
                    },
                    fixed: 'right',
                  },
                  i,
                );
              }
              if (i.renderType === 'switch') {
                return _objectSpread(
                  {
                    render: function render(text, record, index) {
                      if (i.key || i.dataIndex)
                        return /*#__PURE__*/ React.createElement(Switch, {
                          onChange: function onChange(checked) {
                            var _i$onChange;
                            (_i$onChange = i.onChange) === null || _i$onChange === void 0
                              ? void 0
                              : _i$onChange.call(i, checked, record, index);
                          },
                          checked: record[i.key || i.dataIndex],
                        });
                    },
                  },
                  i,
                );
              }
              return i;
            })) !== null && _table$columns$filter !== void 0
      ? _table$columns$filter
      : [];
  return _objectSpread(
    _objectSpread({}, table),
    {},
    {
      columns: columns,
      rowSelectionEnhance: rowSelectionEnhance,
    },
  );
}
